import React, { useRef, useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import Select from 'react-select';
import { IMAGES } from '../constants/theme';
import Header from '../layouts/Header';
import { Link } from 'react-router-dom';

/* ================================
   ✅ ENV VARIABLES (SECURED)
================================ */
const API_BASE = (process.env.REACT_APP_API_BASE_URL || '').trim();
const API_URL = `${API_BASE}/courses/categories`;

const EMAIL_SERVICE_ID = (process.env.REACT_APP_EMAILJS_SERVICE_ID || '').trim();
const EMAIL_TEMPLATE_ID = (process.env.REACT_APP_EMAILJS_TEMPLATE_ID_APPOINTMENT || '').trim();
const EMAIL_PUBLIC_KEY = (process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '').trim();

const Appointment = () => {
  const form = useRef();
  const [options, setOptions] = useState([{ value: '', label: 'Select Service' }]);
  const [selectedService, setSelectedService] = useState(options[0]);
  const [loading, setLoading] = useState(true);

  /* ================================
      ✅ FETCH SERVICES
  ================================= */
  useEffect(() => {
    async function fetchCategories() {
      try {
        setLoading(true);
        const res = await fetch(API_URL);
        if (!res.ok) throw new Error('Failed to fetch categories');

        const categories = await res.json();
        const categoryOptions = [
          { value: '', label: 'Select Service' },
          ...categories.map(category => ({
            value: category.id,
            label: category.name,
          })),
        ];

        setOptions(categoryOptions);
        setSelectedService(categoryOptions[0]);
      } catch (error) {
        console.error('Error fetching categories:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchCategories();
  }, []);

  /* ================================
      ✅ SEND EMAIL (SECURED)
  ================================= */
  const sendEmail = (e) => {
    e.preventDefault();

    if (!selectedService || !selectedService.value) {
      alert('Please select a service');
      return;
    }

    // If EmailJS is configured, use it (client-side). Otherwise POST to backend.
    if (EMAIL_SERVICE_ID && EMAIL_TEMPLATE_ID && EMAIL_PUBLIC_KEY) {
      const payload = {
        name: form.current.elements.name?.value?.trim() || '',
        email: form.current.elements.email?.value?.trim() || '',
        service: selectedService?.label || form.current.elements.service?.value || 'Not specified',
      };

      emailjs.send(EMAIL_SERVICE_ID, EMAIL_TEMPLATE_ID, payload, EMAIL_PUBLIC_KEY)
        .then(
          () => {
            alert('Appointment request sent successfully!');
            form.current.reset();
            setSelectedService(options[0]);
          },
          (error) => {
            console.error('EmailJS Error:', error);
            alert('Failed to send message. Please try again.');
          }
        );
      return;
    }

    // Fallback: send to backend which uses Nodemailer
    (async () => {
      try {
        const formData = new FormData(form.current);
        const payload = {
          name: formData.get('name'),
          email: formData.get('email'),
          service: formData.get('service'),
        };

        const res = await fetch(`${API_BASE}/appointments`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const err = await res.json().catch(() => null);
          throw new Error(err?.error || 'Failed to send appointment');
        }

        alert('Appointment request sent successfully!');
        form.current.reset();
        setSelectedService(options[0]);
      } catch (err) {
        console.error('Backend appointment error:', err);
        alert('Failed to send message. Please try again.');
      }
    })();
  };

  /* ================================
      ✅ UI
  ================================= */
  return (
    <div className="page-wraper">
      <Header />

      <style>{`
        .appointment-form input::placeholder { color: #fff !important; }
      `}</style>

      <div className="page-content bg-white">
        <section
          className="appointment-page"
          style={{ backgroundImage: `url(${IMAGES.BgAppoint})` }}
        >
          <div className="container">
            <div className="section-head">
              <span className="sub-title">Get in Touch</span>
              <h2 className="title">
                Schedule An <span>Appointment</span>
              </h2>
            </div>

            <form className="appointment-form dzForm" ref={form} onSubmit={sendEmail}>

              <p className="appointment-text">
                Hey, My Name is{" "}
                <input
                  name="name"
                  required
                  type="text"
                  className="form-control d-inline-block w-auto"
                  placeholder="Name"
                  style={{ color: '#fff' }}
                />, and I'm looking for:
              </p>

              <Select
                options={options}
                value={selectedService}
                onChange={setSelectedService}
                isSearchable={false}
                isDisabled={loading}
                className="custom-react-select mt-2"
                placeholder="Select Service"
                styles={{
                  singleValue: (provided) => ({ ...provided, color: '#fff' }),
                  control: (provided) => ({ ...provided, color: '#fff' }),
                }}
              />

              <input type="hidden" name="service" value={selectedService?.label || ''} />

              <p className="appointment-text mt-2">
                Get in consult with us at{" "}
                <input
                  name="email"
                  required
                  type="email"
                  className="form-control d-inline-block w-auto"
                  placeholder="Your Email"
                  style={{ color: '#fff' }}
                />!
              </p>

              <div className="form-check mt-2">
                <input className="form-check-input" type="checkbox" required />
                <label className="form-check-label">
                  I hereby accept all terms and conditions.
                </label>
              </div>

              <button
                type="submit"
                className="btn btn-lg btn-skew mt-3"
                style={{ backgroundColor: "#000", borderColor: "#000", color: "#fff" }}
              >
                <span>Appointment</span>
              </button>

            </form>
          </div>
        </section>
      </div>

      <footer className="site-footer style-1 bg-img-fix footer-action" id="footer">
        <div className="footer-bottom text-center">
          <span className="copyright-text">
            Copyright © 2023{" "}
           
            . All rights reserved.
          </span>
        </div>
      </footer>
    </div>
  );
};

export default Appointment;
